/**
 * Authentication Component
 *
 * @constructor
 */

export default function()
{

    const triggers = document.querySelectorAll('a.switch-to')
    const body = document.getElementsByTagName('body')[0]

    for(const trigger of triggers) {
        trigger.addEventListener('click', function(event){
            event.preventDefault()
            const view = this.dataset.view
            body.className = 'form-page ' + view
        })
    }

}
